// extracted by mini-css-extract-plugin
export default {"SearchPanel":"SearchPanel_SearchPanel__gMz0y","actions":"SearchPanel_actions__8WBd3"};